
<div class="multiselect-with-icon" :type="type" :iconBackground="iconBackground">
	<slot />
</div>
